/* prettier-ignore */

import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { catchError, of, throwError } from 'rxjs';
import { DebugService } from 'src/app/services/debug.service';
import { SaveChat } from 'src/chatbot/interface/saveChat.interface';
import { DataChatService } from 'src/chatbot/service/dataChat.service';
import { RequestService } from 'src/chatbot/service/request.service';

@Component({
  selector: 'save-chat-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule
  ],
  templateUrl: './saveChatForm.component.html',
  styleUrl: './saveChatForm.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SaveChatFormComponent {
  private debugService = inject(DebugService);
  
  public dataChat = inject(DataChatService);
  public requestService = inject(RequestService);
  public formBuilder = inject(FormBuilder);
  public sendChat: FormGroup;
  public inputLeads?: (string | null)[];

  constructor(){
    this.sendChat = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      name: [''],
    });
  }

  saveChat(form: SaveChat) {
    if (this.sendChat.invalid) {
      this.debugService.error('invalid form', '[SaveChatFormComponent]');
      return;
    }
    this.dataChat.isSendingChat.set(true);
    let email: string = form.email;
    let name: string | null = form.name || null;

    this.requestService
      .saveChat(email, name)
      .pipe(
        catchError((err: Error) => {
          this.debugService.error(err, '[SaveChatFormComponent] Error Saving Chat');

          this.dataChat.toggleFormVisibility.set(false);
          this.dataChat.toggleErrorMessage.set(true);
          this.dataChat.isSendingChat.set(false);
          return throwError(() => new Error('HTTP request failed', { cause: err }));
        })
      )
      .subscribe((res) => {
        this.debugService.debug(res, '[SaveChatFormComponent] Saving Chat API Response');
        this.dataChat.toggleFormVisibility.set(false);
        this.dataChat.toggleSuccessMessage.set(true);
        this.dataChat.isSendingChat.set(false);
      });
  }

 }
